import React from 'react';
import './ResultCount.css';

export const ResultCount = ({ resultsFor, count, terms }) => {
    return <div className="results-count-wrapper">
        {
            <>
                <div className="result-count">{count + ' '}
                    {resultsFor} &nbsp;
                </div>
                <div className="search-term">{terms}</div>
            </>
        }
    </div>;
};
